<template>
  <div
    :class="{
      row: true,
      'bg-white': true,
      'accesory-box': true,
      'green-border': merchant_id === this.default_id && accessory.dij === 0,
    }"
  >
    <div class="col form-group d-flex align-items-center mb-2">
      <span class="w-100">
        <h3 class="h5 mt-3 fw-bold">{{ accessory.nev }}</h3>
        <button
          v-if="selectable"
          type="button"
          class="info me-2"
          :id="`${aKey}-tooltip`"
          data-toggle="tooltip"
          data-placement="right"
        >
          ?
        </button>
        <small v-if="selected || !selectable">
          <span v-if="accessory.sokszorozhato > 1"
            >Biztosítási összeg: {{ accessoryLimit | currency }}</span
          >
          <span v-else-if="accessory.tovabbi_adatok"
            >Biztosítási összeg: {{ getLimitSum | currency }}</span
          >
          <span v-else
            >Biztosítási összeg: {{ accessory.limit | currency }}</span
          >
          <!-- <span v-if="customEnding">{{ customEnding }}</span> -->
        </small>
      </span>
    </div>
    <!-- kiírja az éves díjat / (választott) limit -->
    <div v-if="selectable" class="col-sm-3 d-flex align-items-center">
      <span
        v-if="typeof accessory.dij == 'number' && accessory.dij >= 0"
        :class="{
          'piros-shadow': accessory.dij === 0,
          'px-2': accessory.dij === 0,
        }"
      >
        <span v-if="accessory.sokszorozhato > 1">
          <b :style="{ color: accessory.dij === 0 ? 'red' : '' }"
            >+{{
              (accessory.dij * (accessoryLimit / accessory.limit)) | currency
            }}</b
          >
          / {{ accessoryLimit | currency }}
        </span>
        <span v-else>
          <b :style="{ color: accessory.dij === 0 ? 'red' : '' }"
            >+{{ accessory.dij | currency }}</b
          >
          / év
        </span>
      </span>
      <!-- <span v-else v-html="insuranceFee"> </span> -->
    </div>
    <!-- utolsó oldalhoz kell csak, hogy kiírja a biztosítottak számát -> akkor, ha selectable false és vannak biztosítottak! -->
    <div
      v-else-if="typeof accessory.biztositottak_szama === 'number'"
      class="mb-2"
    >
      <small>
        <span> Biztosítottak száma: {{ insuredPersons.length }} </span>
      </small>
    </div>
    <!--  checkbox setup -->
    <div
      v-if="selectable"
      class="col-sm-3 d-flex align-items-center justify-content-sm-end my-3"
    >
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input dark-border"
          :id="aKey"
          :name="`${aKey}[]`"
          :checked="selected"
          :value="selected ? '1' : '0'"
          @click="setChosenAccessories(aKey)"
          :disabled="isCheckboxDisabled"
        />
        <label :for="aKey" class="form-check-label">Kérem</label>
      </div>
    </div>
    <!--  sokszorozható limites választható kieg setup -->
    <div v-if="accessory.sokszorozhato > 1 && selected && selectable">
      <label class="col-sm-4 ps-2">Limitek:</label>
      <div>
        <ul class="accessory-limit-list">
          <li v-for="index in accessory.sokszorozhato" :key="index">
            <input
              class="form-check-input"
              type="radio"
              :name="`${aKey}_limit`"
              :id="`${aKey}_${index}`"
              :value="accessory.limit * index"
              v-model="accessoryLimit"
              :checked="index === accessoryLimit / accessory.limit"
            />
            <label class="form-check-label" :for="`${aKey}_${index}`">
              {{ (accessory.limit * index) | currency }}
            </label>
            <ValidationProvider v-show="false" rules="required">
              <input type="text" :value="accessoryLimit" />
            </ValidationProvider>
          </li>
        </ul>
      </div>
    </div>
    <!-- kézzel beírható összeges választható kieg setup ~ kiemelt ingóság/mezőgazdaság/értéktárgy -->
    <div v-if="accessory.tovabbi_adatok && selected && selectable" class="mb-2">
      <!-- sum input mező validáció - arra az esetre, ha van összérték max biztösszeg -->
      <ValidationProvider
        :rules="{
          required: true,
          currency_min: 1,
          currency_max: accessory.max_bo ? accessory.max_bo : false,
        }"
        :immediate="true"
        v-slot="{ errors }"
        class="col-sm-8"
      >
        <input
          :name="`${aKey}_osszesen`"
          v-show="false"
          type="text"
          :value="getLimitSum"
          :aria-describedby="`${aKey}-sum-error`"
        />
        <small :id="`${aKey}-sum-error`" class="text-danger input-alert">{{
          errors[0]
        }}</small>
      </ValidationProvider>
      <!-- <ValidationProvider 
            v-if="accessory.kod === 'ertektargy'"
            :rules="{required: true, min_value: 1, max_value: maxertekek.ertektargy_max }"
            :immediate="true"
            v-slot="{errors}"
            class="col-sm-8">
          <input name="ertektargy_osszesen" v-show="false" type="text" :value="getLimitSum" aria-describedby="ertektargy-sum-error">
          <small id="ertektargy-sum-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
        </ValidationProvider>
        <ValidationProvider
            v-else
            rules="required|min_value:1"
            :immediate="true"
            v-slot="{errors}"
            class="col-sm-8">
          <input :name="`${aKey}_osszesen`" v-show="false" type="text" :value="getLimitSum" :aria-describedby="`${aKey}-sum-error`">
          <small :id="`${aKey}-sum-error`" class="text-danger input-alert">{{
              errors[0]
            }}</small>
        </ValidationProvider> -->
      <div
        class="form-group row"
        v-for="adat in orderedTovabbiAdatok"
        :key="accessoryAdat(adat).kod"
      >
        <label class="col-sm-4 py-2 px-3" :for="accessoryAdat(adat).kod">{{
          accessoryAdat(adat).nev
        }}</label>
        <ValidationProvider
          :rules="{
            required: true,
            currency_min: 0,
            currency_max: accessoryAdat(adat).max_bo
              ? accessoryAdat(adat).max_bo
              : false,
          }"
          v-slot="{ errors, classes }"
          class="col-sm-8"
        >
          <div class="input-group my-1">
            <input
              :id="accessoryAdat(adat).kod"
              :name="accessoryAdat(adat).kod"
              v-currency="{
                locale: 'hu',
                valueAsInteger: true,
                valueRange: { min: 0, max: accessoryAdat(adat).max_bo },
                allowNegative: false,
              }"
              class="form-control"
              :class="{ classes, 'dark-border': true }"
              @input="
                updateSpecialAccessory(
                  accessoryAdat(adat).kod,
                  $event.target.value,
                )
              "
              :value="getSpecialAccessoryValue(accessoryAdat(adat).kod)"
            />
            <div class="input-group-append d-block dark-border">
              <span class="input-group-text" :id="`${aKey}-prepend`">Ft</span>
            </div>
          </div>
          <small :id="`${aKey}-error`" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
        <!-- <ValidationProvider
            v-else-if="accessory.kod === 'mezogazdasag'"
            rules="required|currency_min:0|currency_max:1000000"
            v-slot="{errors, classes}"
            class="col-sm-8"
          >
            <div class="input-group my-1">
              <input
                v-currency="{valueRange: {min: 0, max: 1000000}}"
                class="form-control"
                :id="accessory.tovabbi_adatok[adat].kod"
                :name="accessory.tovabbi_adatok[adat].kod"
                :aria-describedby="`${accessory.tovabbi_adatok[adat].kod}-prepend`"
                :class="classes"
                @input="updateSpecialAccessory(accessory.tovabbi_adatok[adat].kod, $event.target.value)"
                :value="getSpecialAccessoryValue(accessory.tovabbi_adatok[adat].kod)"
              />
              <div class="input-group-append d-block">
                <span class="input-group-text" :id="`${accessory.tovabbi_adatok[adat].kod}-prepend`">Ft</span>
              </div>
            </div>
            <small :id="`${accessory.tovabbi_adatok[adat].kod}-error`" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <ValidationProvider
            v-else
            rules="required|currency_min:0|currency_max:30000000"
            v-slot="{errors, classes}"
            class="col-sm-8"
          >
            <div class="input-group my-1">
              <input
                v-currency="{valueRange: {min: 0, max: 30000000}}"
                class="form-control"
                :id="accessory.tovabbi_adatok[adat].kod"
                :name="accessory.tovabbi_adatok[adat].kod"
                :aria-describedby="`${accessory.tovabbi_adatok[adat].kod}-prepend`"
                :class="classes"
                @input="updateSpecialAccessory(accessory.tovabbi_adatok[adat].kod, $event.target.value)"
                :value="getSpecialAccessoryValue(accessory.tovabbi_adatok[adat].kod)"
              />
              <div class="input-group-append d-block">
                <span class="input-group-text" :id="`${accessory.tovabbi_adatok[adat].kod}-prepend`">Ft</span>
              </div>
            </div>
            <small :id="`${accessory.tovabbi_adatok[adat].kod}-error`" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider> -->
      </div>
    </div>
    <!-- biztosítottakat (is) tartalmazó választható kieg setup -->
    <div
      v-if="
        typeof accessory.biztositottak_szama === 'number' &&
          selected &&
          selectable
      "
    >
      <div
        class="form-group row"
        :class="{ 'mb-5': insuredPersons.length > 0 }"
      >
        <label class="col-sm-4" :for="`${this.aKey}_biztositottak_szama`">
          <span v-if="this.aKey === 'utasbiztositas'"
            >Utasbiztosítottak száma<br /><br />
            Ha 2 fő részére szeretne utasbiztosítást kötni kérjük, 2 főt adjon
            hozzá abban az esetben is, ha az egyik biztosított adatai
            megegyeznek az Ön (Szerződő) adataival.<br /><br
          /></span>
          <span v-else-if="this.aKey === 'temetes'"
            >Temetési biztosítottak száma<br /><br
          /></span>
          <span class="text-danger fw-normal"
            >Biztosított olyan természetes személy lehet, aki a jelen kiegészítő
            biztosításra vonatkozó írásbeli ajánlattétel napján nem töltötte be
            a {{ aKey === "utasbiztositas" ? 70 : 65 }}. életévét</span
          >
        </label>
        <div class="col-sm-4 col-md-6 mb-4">
          <ValidationProvider
            rules="required|min_value:1"
            :immediate="true"
            v-slot="{ errors }"
          >
            <input
              class="form-control dark-border"
              type="number"
              readonly
              :value="insuredPersons.length"
              :id="`${aKey}_biztositottak_szama`"
              :name="
                `${
                  aKey === 'utasbiztositas' ? 'utas' : 'temetes'
                }biztositottak_szama`
              "
            />
            <small
              :id="
                `${
                  aKey === 'utasbiztositas' ? 'utas' : 'temetes'
                }biztositottak_szama`
              "
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="col-sm-4 col-md-2">
          <button
            class="add-new-item btn btn-outline-danger w-100"
            @click.prevent="addInsuredPerson(insuredPersons, aKey)"
            :disabled="isDisabled"
          >
            Hozzáadás
          </button>
        </div>
      </div>
      <div v-for="(person, key) in insuredPersons" :key="key">
        <h2 v-if="insuredPersons.length > 1" class="mt-5">
          {{ key + 1 }}. biztosított adatai
        </h2>
        <InsuredPerson
          :person="person"
          :pKey="key"
          :selected="selected"
          :listName="aKey"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { parse } from "vue-currency-input";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex/dist/vuex.common.js";
import InsuredPerson from "./InsuredPerson";
import _ from "lodash";

const _defaultAppliedOnce = Object.create(null);
export default {
  data() {
    return {
      _autoDefaultApplied: false,
    };
  },
  components: {
    InsuredPerson,
  },
  props: ["aKey", "selectable"],
  computed: {
    accessory() {
      // console.log(this.valaszthatoKiegeszitok)
      return this.valaszthatoKiegeszitok[this.chosenPackage][this.aKey];
    },
    selected: {
      get() {
        return !!this.chosenAccessories?.[this.aKey]?.selected;
      },
      set() {
        this.setChosenAccessories(this.aKey);
      },
    },
    accessoryLimit: {
      // get() {
      //   return (
      //     this.valaszthatoKiegeszitok[this.chosenPackage][this.aKey].limit *
      //     this.chosenAccessories[this.aKey].limit
      //   );
      // },
      get() {
        const mult = this.chosenAccessories?.[this.aKey]?.limit ?? 1;
        return this.accessory.limit * mult;
      },
      set(value) {
        this.updateChosenAccessory({
          kod: this.aKey,
          limit: value / this.accessory.limit,
          tovabbiAdatok: null,
          utasInfok: null,
        });
      },
    },
    insuredPersons: {
      get() {
        return this.chosenAccessories[this.aKey].biztositottak;
      },
    },
    getLimitSum() {
      return Object.keys(this.accessory.tovabbi_adatok).reduce((acc, cv) => {
        // return acc + parse(this.chosenAccessories[this.aKey].tovabbi_adatok[cv].toString())
        const regex = /\s/g;
        return (
          acc +
          parseInt(
            this.chosenAccessories[this.aKey].tovabbi_adatok[cv]
              .toString()
              .replace(regex, ""),
          )
        );
      }, 0);
    },
    orderedTovabbiAdatok() {
      // console.log(this.accessory)
      return _.sortBy(
        Object.keys(this.accessory.tovabbi_adatok),
        (item) => this.accessory.tovabbi_adatok[item].sorrend,
      );
    },
    isDisabled() {
      return (
        (this.aKey === "temetes" &&
          parseInt(this.residents) === parseInt(this.insuredPersons.length)) ||
        (this.aKey === "utasbiztositas" &&
          parseInt(this.insuredPersons.length) === 10)
      );
      // return (this.aKey === 'temetes' || this.aKey === 'utasbiztositas') && parseInt(this.residents) === parseInt(this.insuredPersons.length)
    },
    isCheckboxDisabled() {
      return (
        (this.aKey === "baleset_kis" &&
          this.chosenAccessories.baleset_nagy.selected) ||
        (this.aKey === "baleset_nagy" &&
          this.chosenAccessories.baleset_kis.selected)
      );
    },
    // ertektargySum() {
    //   return Object.keys(this.accessory.tovabbi_adatok).reduce((acc, cv) => {
    //     return acc + parse(this.chosenAccessories.ertektargy.tovabbi_adatok[cv])
    //   }, 0)
    // },
    ...mapFields([
      "chosenAccessories",
      "chosenPackage",
      "valaszthatoKiegeszitok",
      "insuranceProperty.residents",
      "maxertekek",
      "merchant_id",
      "default_id",
    ]),
    ...mapFields({
      insuredPersonTemplate: "chooseableAccesories.personTemplate",
    }),
  },

  watch: {
    accessory: {
      immediate: true,
      handler(acc) {
        if (!this.selectable) return;
        if (!acc?.default) return;

        // kulcs: ha csomag váltás is számít, így külön kezeljük
        const onceKey = `${this.chosenPackage || "nopack"}:${this.aKey}`;

        // csak egyszer fusson le (komponens újramountnál se)
        if (_defaultAppliedOnce[onceKey]) return;

        const def = Number(acc.default);
        if (!Number.isFinite(def) || def < 1) return;

        // ha még nincs kiválasztva: válasszuk ki
        // if (!this.selected) {
        //   this.setChosenAccessories(this.aKey);
        // }

        // limit legyen a default (index/szorzó)
        this.updateChosenAccessory({
          kod: this.aKey,
          limit: def, // <-- 6
          tovabbiAdatok: null,
          utasInfok: null,
        });

        // megjegyezzük, hogy lefutott
        _defaultAppliedOnce[onceKey] = true;
      },
    },
  },

  methods: {
    ...mapActions(["updateChosenAccessory", "setChosenAccessories"]),
    updateSpecialAccessory(adat_kod, value) {
      const extraData = {};
      extraData[adat_kod] = value;
      this.$store.dispatch("updateChosenAccessory", {
        kod: this.aKey,
        limit: null,
        tovabbiAdatok: extraData,
        utasInfok: null,
      });
    },
    getSpecialAccessoryValue(adat_kod) {
      return this.chosenAccessories[this.aKey].tovabbi_adatok[adat_kod];
    },
    addInsuredPerson(insuredPersons, listName) {
      if (insuredPersons.length < 10)
        this.$store.commit("addInsuredPerson", {
          listName: listName,
          person: Object.assign({}, this.insuredPersonTemplate),
        });
    },
    accessoryAdat(adat) {
      return this.accessory.tovabbi_adatok[adat];
    },
  },
};
</script>

<style lang="scss">
.accesory-box {
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;

  h3 {
    word-break: normal;
    word-wrap: break-word;
    white-space: pre-wrap;
  }
}

.accessory-limit-list {
  list-style-type: none;
}
// div > div > span.piros-shadow {
//   // text-shadow: 0px 0px 20px #E4002B !important;

// }

div > div.green-border {
  border: 2px solid #00ab8e !important;
}
</style>
